export function getUTCDate (timestamp: Date) {
    // Create a date object from the timestamp

    let date = new Date(timestamp) as any;
    const dd = String(date.getUTCDate()).padStart(2, '0');
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getUTCFullYear();

    date = dd + '/'+ mm + '/' +  yyyy;

    return date;
    
}


export function formatFullDate(timestamp: Date): string {
    if (!timestamp) {
        return '';
    }

    // Create a date object from the timestamp
    const date = new Date(timestamp);

    // Format the date and time separately
    const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        weekday: 'short',
        month: 'long',
        day: 'numeric',
    });

    const timeFormatter = new Intl.DateTimeFormat('en-GB', {
        hour: 'numeric',
        minute: 'numeric',
    });

    // Get formatted date and time
    const formattedDate = dateFormatter.format(date);
    const formattedTime = timeFormatter.format(date);

    // Combine date and time with a comma
    return `${formattedDate}, ${formattedTime}`;
}

export function getAddress(address: any): string {
    if (!address) return '';

    const parts: string[] = [];

    // Add address line 1
    if (address.address_line1) {
        parts.push(address.address_line1.trim());
    }

    // Add city name
    if (address.city?.name) {
        parts.push(address.city.name.trim());
    }

    // Add country name
    if (address.city?.country?.name) {
        parts.push(address.city.country.name.trim());
    }

    // Join the parts with a space and return the formatted address
    return parts.join(', ');
}


export function getUTCDateTime(dateTime: string): Date {
    const date = new Date(dateTime);
    return new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
    ));
}

export function isBeforeTheDefinedTime(targetDateTime: string, definedTime: number): boolean {
    // Convert the target date to its UTC equivalent
    const targetDateUTC = getUTCDateTime(targetDateTime);

    // Subtract the defined time in minutes from the target date
    const definedTimeBeforeTarget = new Date(targetDateUTC.getTime() - definedTime * 60 * 1000);

    // Get the current date and time in UTC
    const currentDateUTC = new Date();

    // Check if the current UTC time is before the defined time window
    return currentDateUTC <= definedTimeBeforeTarget;
}
